import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { useFetchMyPlaylistContent } from 'actions/playlists';
import { FILE_STATUS_VALUES } from 'actions/file';
import createLocation from 'utils/createLocation';
import { truncateText } from 'utils/ui';
import Box from 'components/Box';
import { Arrow } from 'components/icons';
import Flex from 'components/Flex';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
var StickyFlex = styled(Flex).withConfig({
  displayName: "PlaylistNavigator__StickyFlex",
  componentId: "sc-7i8vpi-0"
})(["position:relative;@media (min-height:580px){position:sticky;}"]);
function getNextAsset(currentAssetId, contents) {
  if (!contents.length) return {
    nextAsset: null,
    currentPosition: null,
    assetCount: null
  };
  var allAssets = contents.filter(function (content) {
    return content.type !== 'playlist' && content.type !== 'section';
  });
  var readyAssets = allAssets.filter(function (asset) {
    return asset.fileStatus === FILE_STATUS_VALUES.READY || asset.type === 'web';
  });
  var currentAssetIndex = allAssets.findIndex(function (_ref) {
    var id = _ref.id;
    return id === currentAssetId;
  });
  var nextAsset = null;
  if (currentAssetIndex !== -1 && readyAssets[currentAssetIndex + 1]) {
    nextAsset = readyAssets[currentAssetIndex + 1];
  }
  return {
    nextAsset: nextAsset,
    currentPosition: currentAssetIndex + 1,
    assetCount: allAssets.length
  };
}
var MiddleDot = function MiddleDot() {
  return /*#__PURE__*/React.createElement(Box, {
    width: 2,
    height: 2,
    mx: "xs",
    background: "text"
  });
};
function PlaylistNavigator(_ref2) {
  var assetId = _ref2.assetId,
    playlistId = _ref2.playlistId,
    playlistName = _ref2.playlistName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useFetchMyPlaylistCo = useFetchMyPlaylistContent({
      id: playlistId
    }),
    content = _useFetchMyPlaylistCo.items,
    isLoading = _useFetchMyPlaylistCo.isLoading,
    isError = _useFetchMyPlaylistCo.isError;
  if (isLoading || isError) {
    return null;
  }
  var _getNextAsset = getNextAsset(assetId, content),
    nextAsset = _getNextAsset.nextAsset,
    currentPosition = _getNextAsset.currentPosition,
    assetCount = _getNextAsset.assetCount;
  var nextAssetLink = nextAsset && createLocation(pathname, {
    asset: nextAsset.id,
    playlistId: playlistId
  });
  return /*#__PURE__*/React.createElement(StickyFlex, {
    bottom: true,
    mt: "auto",
    px: "m",
    py: "s",
    background: "shaded",
    borderTop: "thin",
    fontSize: "xs",
    lineHeight: 1.4
  }, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    overflow: "wrap",
    mr: "s"
  }, nextAssetLink ? /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    stealthy: true,
    as: Link,
    to: nextAssetLink
  }, truncateText(t('asset_next_content', {
    name: nextAsset.name
  }), 75), /*#__PURE__*/React.createElement(Box, {
    fillParent: true
  })) : /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t('end_of_playlist')), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    overflow: "ellipsis"
  }, playlistName), /*#__PURE__*/React.createElement(MiddleDot, null), /*#__PURE__*/React.createElement(Box, null, t('pagination_current_slash_total', {
    current: currentPosition,
    total: assetCount
  })))), nextAsset && /*#__PURE__*/React.createElement(Box, {
    ml: "auto",
    mr: "-xxs",
    textColor: "links"
  }, /*#__PURE__*/React.createElement(Arrow, {
    disablePointerEvents: true,
    flip: "x"
  })));
}
export default PlaylistNavigator;